import React from 'react';
import PropTypes from 'prop-types';
import styles from './ProgressBar.module.less';

const ProgressBar = (props) => {
  return (
    <div className={styles.background}>
      <div className={styles.progress} style={{ width: `${props.percentage}%`, transition: 'width 0.4s ease' }} />
    </div>
  );
};

ProgressBar.propTypes = {
  percentage: PropTypes.number,
};
export default ProgressBar;
